import './Academic.css'
import { Route, Routes } from "react-router";
import MainLayout from "../../layouts/MainLayout/MainLayout";
import ViewLayout from "../../layouts/ViewLayout/ViewLayout";
import AcademicHome from "../../features/Academic/AcademicHome/AcademicHome";
import AcademicUsersView from '../../features/Academic/AcademicUsers/AcademicUserView/AcademicUsersView';
import AcademicSpecialtiesContainer from "../../features/Academic/AcademicSpecialtiesContainer/AcademicSpecialtiesContainer";
import AcademicUnitsContainer from "../../features/Academic/AcademicUnitsContainer/AcademicUnitsContainer";
import {withAcademicContextReady, withAcademicContextProvider} from "../../contexts/AcademicContext";
import AcademicValorationsContainer from '../../features/Academic/AcademicValorationsContainer/AcademicValorationsContainer';
import AcademicLibraryContainer from '../../features/Academic/AcademiLibrary/AcademicLibraryContainer/AcademicLibraryContainer';
import AcademicSubscriptionsContainer from '../../features/Academic/AcademicSubscriptionsContainer/AcademicSubscriptionsContainer';
import AcademicLessonPreview from '../../features/Academic/AcademicLessonPreview/AcademicLessonPreview';
import AcademicPacksContainer from '../../features/Academic/AcademicPacks/AcademicPacksContainer';


const Academic = () => {
   return (
      <MainLayout>
         <Routes>
            < Route
               path='/'
               element={
                  <ViewLayout
                     title='Académico'
                     description='Aqui podras generar contenido específico para la sección relacionadas a lo Académico del sitio web y del campus.'
                  >
                     < AcademicHome />
                  </ViewLayout>
               }
            />
             < Route
                 path='/unidades-academicas'
                 element={
                     <ViewLayout
                         title='Unidades Académicas'
                         description='Aquí podrás editar las unidades académicas existentes o crear una nueva.'
                         backBtnText='Ir a Académico'
                         withBackButton
                     >
                        <>
                         <AcademicUnitsContainer />
                         <AcademicLessonPreview/>
                         </>
                     </ViewLayout>
                 }
             />
            <Route
               path='/packs'
               element={
                  <ViewLayout
                     title='Packs'
                     description='Crear y editar packs: combos de unidades académicas completas que se venden juntas. Quien compra un pack queda inscripto en cada curso.'
                     backBtnText='Ir a Académico'
                     withBackButton
                  >
                     <AcademicPacksContainer />
                  </ViewLayout>
               }
            />
            < Route
               path='/usuarios'
               element={
                  <ViewLayout
                     title='Usuarios'
                     description='Aqui podras generar contenido específico para la sección relacionadas a los usuarios.'
                     backBtnText='Ir a Académico'
                     withBackButton
                  >
                     < AcademicUsersView />
                  </ViewLayout>
               }
            />
             < Route
                 path='/especialidades'
                 element={
                     <ViewLayout
                         title='Especialidades'
                         description='Aquí podrás editar las especialidades existentes o crear una nueva.'
                         backBtnText='Ir a Académico'
                         withBackButton
                     >
                         < AcademicSpecialtiesContainer />
                     </ViewLayout>
                 }
             />
             < Route
                 path='/valoraciones'
                 element={
                     <ViewLayout
                         title='Valoraciones'
                         description='Aquí podrás ver y revisar todas las valoraciones de las clases dadas'
                         backBtnText='Ir a Académico'
                         withBackButton
                     >
                         < AcademicValorationsContainer />
                     </ViewLayout>
                 }
             />
             < Route
                 path='/planes-de-suscripcion'
                 element={
                     <ViewLayout
                         title='Planes de suscripción'
                         description='Crear y editar planes.'
                         backBtnText='Ir a Académico'
                         withBackButton
                     >
                         < AcademicSubscriptionsContainer />
                     </ViewLayout>
                 }
             />
              < Route
                 path='/biblioteca-de-contenido'
                 element={
                     <ViewLayout
                         title='Biblioteca'
                         description='Aquí podrás crear y editar la biblioteca de contenidos.'
                         backBtnText='Ir a Académico'
                         withBackButton
                     >
                         < AcademicLibraryContainer />
                     </ViewLayout>
                 }
             />
         </Routes>
      </MainLayout>
   );
};

export default withAcademicContextProvider(withAcademicContextReady(Academic));
